import { Typography, TypographyProps } from '@mui/material'
import { ReactNode } from 'react'
import { CopyToClipboard } from '../copy-to-clipboard'

interface InfoItemProps extends TypographyProps {
  label: string
  value?: string | number | ReactNode
  vertical?: boolean
  enableCopy?: boolean
}

export const InfoItem = ({
  label,
  value,
  children,
  vertical,
  enableCopy,
  ...props
}: InfoItemProps) => {
  const displayValue = children || value || '--'
  return (
    <Typography sx={{ mb: 0.5, ':last-of-type': { mb: 0 } }} {...props}>
      <strong>
        {label}
        {!vertical && ':'}
      </strong>{' '}
      {vertical && <br />}
      {displayValue}
      {enableCopy && <CopyToClipboard value={displayValue} />}
    </Typography>
  )
}
